import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

import { css, memoizeStyle } from "../../../lib/theming/Emotion";
export var styles = memoizeStyle({
  root: function root() {
    return css(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n      padding-right: 10px;\n    "])));
  },
  absolute: function absolute() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n      position: absolute;\n      top: 0;\n    "])));
  },
  userSelectContain: function userSelectContain() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n      user-select: text;\n      -ms-user-select: element;\n    "])));
  },
  userSelectNone: function userSelectNone() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n      user-select: none;\n    "])));
  },
  rightSide: function rightSide() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n      padding-left: 0;\n      visibility: visible;\n    "])));
  }
});